"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUsers = exports.getUserSummary = exports.getChatSubject = exports.getSelectedChat = void 0;
const chats_1 = require("./model/chats");
function getSelectedChat(chatsState) {
    var _a;
    return chatsState.selectedChatIndex === null
        ? null
        : (_a = chatsState.chats[chatsState.selectedChatIndex]) !== null && _a !== void 0 ? _a : null;
}
exports.getSelectedChat = getSelectedChat;
function getChatSubject(chatsState, chatId) {
    const chat = chatsState.chats.find(c => c.chatId === chatId);
    return chat && chats_1.isGroupChat(chat) ? chat.subject : null;
}
exports.getChatSubject = getChatSubject;
function getUserSummary(them, userDictionary) {
    return them && userDictionary.hasOwnProperty(them)
        ? userDictionary[them]
        : null;
}
exports.getUserSummary = getUserSummary;
function getUsers(userIds, userDictionary) {
    return userIds
        .filter(u => userDictionary.hasOwnProperty(u))
        .map(u => userDictionary[u]);
}
exports.getUsers = getUsers;
